module.exports = __webpack_public_path__ + "static/img/gp-icon3.85075fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/gp-icon3.png
// module id = 12
// module chunks = 0